module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby + Netlify CMS Starter"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/2017-01-04-just-in-small-batch-of-jamaican-blue-mountain-in-store-next-week/"},"frontmatter":{"title":"Introduction"}}}]}},"pathContext":{"tag":"intro"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-intro.json
// module id = 350
// module chunks = 88245472118650